import { useTranslation } from '@eti/providers';
import { Inline, Stack, Text, textVariants } from '@etg/wings';
import { Share } from '@phosphor-icons/react';
import type { RebookEligibilityType } from './models';
import { RebookEligibility } from './models';

const getTextsPerEligibilityType = (type: RebookEligibilityType) => {
  switch (type) {
    case RebookEligibility.CHANGE_SHORT_DEPARTURE:
      return {
        heading: 'OrderDetails.ManageTrip.ShortDeparture.NoChanges.Title',
        description: 'OrderDetails.ManageTrip.ChangeableContactAirline.ShortDeparture.Description',
      };
    case RebookEligibility.CHANGE_EXCHANGED_BY_AIRLINE:
      return {
        description:
          'OrderDetails.ManageTrip.ChangeableContactAirline.ExchangeByAirline.Description',
      };
    default:
      return {};
  }
};

interface OrderChangeabilityContactAirlineProps {
  rebookEligibilityType: RebookEligibilityType;
}

const OrderChangeabilityContactAirline = ({
  rebookEligibilityType,
}: OrderChangeabilityContactAirlineProps) => {
  const { t } = useTranslation();

  const { heading = null, description = null } = getTextsPerEligibilityType(rebookEligibilityType);

  return (
    <Stack data-testid="order-changeability-contact-airline">
      <Text variant={textVariants._16_BOLD}>
        {t(heading) || t('OrderDetails.ManageTrip.ChangeableContactAirline.Title')}
      </Text>
      <Stack align="start" spacing={8}>
        <Text>
          {t(description) || t('OrderDetails.ManageTrip.ChangeableContactAirline.Description')}
        </Text>
        <a
          aria-label={`${t(
            'OrderDetails.ManageTrip.AirlineContactInformationLink.Description',
          )}, ${t('ScreenReader.Link.OpensInNewTab.AriaLabel.Text')}`}
          data-testid="airline-contact-info-link"
          href="/rf/carriers"
          rel="noreferrer"
          target="_blank"
        >
          <Inline alignY="center" spacing={4}>
            <Text>{t('OrderDetails.ManageTrip.AirlineContactInformationLink.Description')}</Text>
            <Share aria-hidden="true" size={20} />
          </Inline>
        </a>
      </Stack>
    </Stack>
  );
};

export default OrderChangeabilityContactAirline;
